
import {IUserLogEntryBuilder} from './i.user.log.entry.builder';
import {IUserLogEntryOptions} from './i.user.log.entry.options';

/**
 *
 * @class DoubleTrackParkingBuilder
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2021
 *
 */
export class DoubleTrackParkingBuilder implements IUserLogEntryBuilder {

  /** convert raw MongoDB user log entry into data that can construct a tree node */
  build(data: any, args: IUserLogEntryOptions): any {

    const u:      string = data._id.match(/^double-track-park-(.*)/i)[1];
    const depDir: string = data.r ? 'REV' : 'FWD';
    const dir:    string = data.dd;

    return {
      id:              data._id,
      seq:             parseInt(data.seq),
      name:            `${depDir} Parking [DOUBLE] ${data.l.n} ${dir}...`,
      hasChildren:     args.hasChildren,
      isExpanded:      args.isExpanded,
      type:            'double-track-park',
      children:        args.children,
      kids:            data.ch,
      tags:            data.tg,
      label:           data.lb,
      pkey:            data.pa,
      parent:          args.parent,
      direction:       data.dd,
      kind:            data.l.k,
      sIndex:          data.l.sx,
      index:           data.l.ix,
      u:               data._id
    };

  }
}
